(() => {
  const DESKTOP = '(min-width: 990px)';
  const TARGET_MENUS = new Set(['COMPRAR']);

  function getHeaderMenu(topLink) {
    return topLink.closest('[header-menu], header-menu');
  }

  function resizeMegaMenu(topLink) {
    const headerMenu = getHeaderMenu(topLink);
    const topItem = topLink.closest('.menu-list__list-item');
    const submenu = topItem?.querySelector('[ref="submenu[]"]');
    if (!headerMenu || !submenu || topLink.getAttribute('aria-expanded') !== 'true') return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (topLink.getAttribute('aria-expanded') !== 'true') return;
        headerMenu.style.setProperty('--submenu-height', `${submenu.scrollHeight}px`);
        headerMenu.style.setProperty('--submenu-opacity', '1');
      });
    });
  }

  function initAccordionFor(topLink) {
    const topItem = topLink.closest('.menu-list__list-item');
    const submenu = topItem?.querySelector('[ref="submenu[]"]');
    const list = submenu?.querySelector('.mega-menu__list');
    if (!list || list.dataset.desktopAccordionReady === 'true') return;

    list.dataset.desktopAccordionReady = 'true';
    list.classList.add('omnia-desktop-accordion');

    [...list.children].forEach((column) => {
      column.classList.add('omnia-desktop-accordion__group');
      [...column.querySelectorAll(':scope > div')].forEach((group) => {
        const heading = group.querySelector(':scope > .mega-menu__link');
        const children = group.querySelector(':scope > ul');
        if (!heading) return;

        heading.classList.remove('mega-menu__link--parent');
        if (!children) return;

        heading.classList.add('omnia-desktop-accordion__trigger');
        children.classList.add('omnia-desktop-accordion__panel');
        children.hidden = true;
        heading.setAttribute('aria-expanded', 'false');

        heading.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const willOpen = children.hidden;

          list.querySelectorAll('.omnia-desktop-accordion__panel').forEach((panel) => { panel.hidden = true; });
          list.querySelectorAll('.omnia-desktop-accordion__trigger').forEach((trigger) => { trigger.setAttribute('aria-expanded', 'false'); });

          if (willOpen) {
            children.hidden = false;
            heading.setAttribute('aria-expanded', 'true');
          }
          resizeMegaMenu(topLink);
        });
      });
    });
  }

  function initDesktopAccordions() {
    if (!window.matchMedia(DESKTOP).matches) return;
    document.querySelectorAll('[header-menu] .menu-list__link[aria-haspopup="true"], header-menu .menu-list__link[aria-haspopup="true"]').forEach((topLink) => {
      const title = topLink.querySelector('.menu-list__link-title')?.textContent.trim().toUpperCase();
      if (TARGET_MENUS.has(title)) initAccordionFor(topLink);
    });
  }

  document.addEventListener('DOMContentLoaded', initDesktopAccordions, { once: true });
  document.addEventListener('shopify:section:load', initDesktopAccordions);
  window.addEventListener('resize', initDesktopAccordions);
  setTimeout(initDesktopAccordions, 500);
})();